export enum Resolution {
  HD = 'HD',
  SD = 'SD',
}

export const RESOLUTION_OPTIONS = [
  { value: Resolution.SD, label: 'SD' },
  { value: Resolution.HD, label: 'HD' },
]
